import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { RecipientsApi, type CreateRecipientRequest, type RecipientResponse } from '@shared/api';
import { Constants } from '@shared/constants';

const createRecipientEffect = createEffect((request: CreateRecipientRequest) => RecipientsApi.createRecipient(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(createRecipientEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createRecipientEffect.pending, (_, data) => data)
  .on(createRecipientEffect.fail, () => false)
  .on(createRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<{ message: string; errorCode?: string | null } | null>(null)
  // .on(createRecipientEffect, () => null)
  .on(createRecipientEffect.fail, (_, data) => {
    const error = ApiUtils.getApiErrorData(data.error, 'Something went wrong while creating Recipient. Please try again.');
    return Constants.VOP_ERROR_CODES.includes(error.errorCode || '') ? error : { message: error.message };
  })
  .on(createRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error?.errorCode ? null : error?.message));

export const $recipientCreateStore = {
  events: {
    createRecipient: createRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
